

































































import Vue from "vue";
import Spinner from "@/components/Spinner.vue";
import StatefulContainer from "@/components/StatefulContainer.vue";
import { NotificationsManager, PollNotification } from "./NotificationManager";
import { onMounted } from "@vue/composition-api";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  components: { Spinner, StatefulContainer },
  setup() {
    const { notifications, remove } = NotificationsManager;

    onMounted(() => {
      AppAnalytics.report({
        component: "General",
        eventName: "Notifications_clicked[Action:Open]",
      });
    });

    const onAction = (
      notif: PollNotification,
      action: { name: string; action: (n: PollNotification) => void }
    ) => {
      action.action(notif);
      AppAnalytics.report({
        component: "General",
        eventName: `Notifications_clicked[Type:${notif.group}, Action:${action.name}]`,
      });
    };

    return {
      onAction,
      notifications,
      remove,
    };
  },
});
